export default {"src":"/_next/static/media/chicken-and-chips.36d0db1e.svg","height":124,"width":160,"blurWidth":0,"blurHeight":0};